import { ReactNode } from 'react'

import useCaseZone from './useCaseZone'

interface CaseZoneProps {
  children: ReactNode
}

const CaseZone = (props: CaseZoneProps) => {
  const { children } = props
  // const { zoneDetails, caseDetails, dossier, loading, error } = useCaseZone()

  // console.log('<CaseZone/>')

  return <>{children}</>
}

export default CaseZone
